import { Component, Fragment, Prop, h } from '@stencil/core';
import { BusinessDistance, FinanceOption, LoanDistance, PrivateDistance, Type } from '../../types';
import state from '../../store';

@Component({
  tag: 'kia-filters',
  shadow: true,
  styleUrl: 'filters.scss',
})
export class Priskort {
  @Prop() types: Type[] = [];
  @Prop() activeType: number | undefined = 9999;
  @Prop() setActiveType: (id: number) => void | undefined;
  @Prop() filterTrimsOnFinanceOption: () => void | undefined;
  @Prop() filteredFinanceOption?: FinanceOption = undefined;

  setActiveFinanceOption = (option: FinanceOption) => {
    state.activeFinanceOption = option;
    this.filterTrimsOnFinanceOption();
  };

  getDistanceOptions = () => {
    switch (state.activeFinanceOption) {
      case FinanceOption.PrivatLeasing:
        return [PrivateDistance.One];
      case FinanceOption.Loan:
        return [LoanDistance.One];
      case FinanceOption.BusinessLease:
        return [BusinessDistance.One, BusinessDistance.Two, BusinessDistance.Three, BusinessDistance.Four];
      default:
        return [];
    }
  };

  setDistance = (distance: string) => {
    switch (state.activeFinanceOption) {
      case FinanceOption.PrivatLeasing:
        state.privateDistance = distance as PrivateDistance;
        break;
      case FinanceOption.Loan:
        state.loanDistance = distance as LoanDistance;
        break;
      case FinanceOption.BusinessLease:
        state.businessDistance = distance as BusinessDistance;
        break;
      default:
        break;
    }
  };

  distanceIsSelected = (distance: string) => {
    switch (state.activeFinanceOption) {
      case FinanceOption.PrivatLeasing:
        return state.privateDistance === distance;
      case FinanceOption.Loan:
        return state.loanDistance === distance;
      case FinanceOption.BusinessLease:
        return state.businessDistance === distance;
      default:
        return false;
    }
  };

  render() {
    return (
      <Fragment>
        <div class="kia_price_list--filter">
          {this.setActiveType && !this.filteredFinanceOption && (
            <div>
              <h5>Drivlina</h5>
              <div class="kia_price_list--types">
                <button class={`${this.activeType === 9999 ? 'active' : ''}`} onClick={() => this.setActiveType(9999)}>
                  Alla
                </button>
                {this.types.map(t => (
                  <button class={`${this.activeType === t.id ? 'active' : ''}`} onClick={() => this.setActiveType(t.id)}>
                    {t.name}
                  </button>
                ))}
              </div>
            </div>
          )}
          {!this.filteredFinanceOption && (
            <div>
              <h5>Finansiering</h5>
              <div class="kia_price_list--finance">
                <button onClick={() => this.setActiveFinanceOption(FinanceOption.All)} class={`${state.activeFinanceOption === FinanceOption.All ? 'active' : ''}`}>
                  {FinanceOption.All}
                </button>
                <button
                  onClick={() => this.setActiveFinanceOption(FinanceOption.PrivatLeasing)}
                  class={`${state.activeFinanceOption === FinanceOption.PrivatLeasing ? 'active' : ''}`}
                >
                  {FinanceOption.PrivatLeasing}
                </button>
                <button onClick={() => this.setActiveFinanceOption(FinanceOption.Loan)} class={`${state.activeFinanceOption === FinanceOption.Loan ? 'active' : ''}`}>
                  {FinanceOption.Loan}
                </button>
                <button
                  onClick={() => this.setActiveFinanceOption(FinanceOption.BusinessLease)}
                  class={`${state.activeFinanceOption === FinanceOption.BusinessLease ? 'active' : ''}`}
                >
                  {FinanceOption.BusinessLease}
                </button>
              </div>
            </div>
          )}

          {state.activeFinanceOption === FinanceOption.PrivatLeasing && (
            <div>
              <h5>Årlig körsträcka</h5>
              <div class="kia_price_list--finance">
                <button onClick={() => (state.privateDistance = PrivateDistance.One)} class={`${state.privateDistance === PrivateDistance.One ? 'active' : ''}`}>
                  {PrivateDistance.One} mil
                </button>
              </div>
            </div>
          )}
          {state.activeFinanceOption === FinanceOption.Loan && (
            <div>
              <h5>Årlig körsträcka</h5>
              <div class="kia_price_list--finance">
                <button onClick={() => (state.loanDistance = LoanDistance.One)} class={`${state.loanDistance === LoanDistance.One ? 'active' : ''}`}>
                  {LoanDistance.One} mil
                </button>
              </div>
            </div>
          )}
          {state.activeFinanceOption === FinanceOption.BusinessLease && (
            <div>
              <h5>Årlig körsträcka</h5>
              <div class="kia_price_list--finance">
                <button onClick={() => (state.businessDistance = BusinessDistance.One)} class={`${state.businessDistance === BusinessDistance.One ? 'active' : ''}`}>
                  {BusinessDistance.One} mil
                </button>
                <button onClick={() => (state.businessDistance = BusinessDistance.Two)} class={`${state.businessDistance === BusinessDistance.Two ? 'active' : ''}`}>
                  {BusinessDistance.Two} mil
                </button>
                <button onClick={() => (state.businessDistance = BusinessDistance.Three)} class={`${state.businessDistance === BusinessDistance.Three ? 'active' : ''}`}>
                  {BusinessDistance.Three} mil
                </button>
                <button onClick={() => (state.businessDistance = BusinessDistance.Four)} class={`${state.businessDistance === BusinessDistance.Four ? 'active' : ''}`}>
                  {BusinessDistance.Four} mil
                </button>
              </div>
            </div>
          )}
        </div>
        <div
          class={`kia_price_list--filter-mobile ${this.filteredFinanceOption ? 'kia_price_list--filter-mobile--withfilter' : ''} ${
            this.setActiveType ? '' : 'kia_price_list--filter-mobile--card'
          }`}
        >
          {this.setActiveType && !this.filteredFinanceOption && (
            <div>
              <h5>Drivlina</h5>
              <div class="kia_price_list--select">
                <select aria-label="Välj drivlina" onChange={e => this.setActiveType(parseInt((e.target as HTMLSelectElement).value))} name="drivlina" id="drivlina">
                  {[{ name: 'Alla', id: 9999 }, ...this.types].map(t => (
                    <option value={t.id}>{t.name}</option>
                  ))}
                </select>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.833496 1.5L5.8335 6.5L10.8335 1.5" stroke="#05141F" stroke-width="2" />
                </svg>
              </div>
            </div>
          )}
          {!this.filteredFinanceOption && (
            <div>
              <h5>Finansiering</h5>
              <div class="kia_price_list--select">
                <select
                  aria-label="Välj Finansiering"
                  onChange={e => (state.activeFinanceOption = (e.target as HTMLSelectElement).value as FinanceOption)}
                  name="finansiering"
                  id="finansiering"
                >
                  {[FinanceOption.All, FinanceOption.PrivatLeasing, FinanceOption.Loan, FinanceOption.BusinessLease].map(c => (
                    <option value={c}>{c}</option>
                  ))}
                </select>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.833496 1.5L5.8335 6.5L10.8335 1.5" stroke="#05141F" stroke-width="2" />
                </svg>
              </div>
            </div>
          )}
          {state.activeFinanceOption !== FinanceOption.All && (
            <div>
              <h5>Årlig körsträcka</h5>
              <div class="kia_price_list--select">
                <select aria-label="Välj körsträcka" onChange={e => this.setDistance((e.target as HTMLSelectElement).value)} name="korstracka" id="korstracka">
                  {this.getDistanceOptions().map(c => (
                    <option selected={this.distanceIsSelected(c)} value={c}>
                      {c + ' mil'}
                    </option>
                  ))}
                </select>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.833496 1.5L5.8335 6.5L10.8335 1.5" stroke="#05141F" stroke-width="2" />
                </svg>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}
